import type Carrier from '~/types/Carrier';

import { type CarrierFormType } from '~/pages/Settings/Carriers/CarrierForm/CarrierForm';
import { type CarrierFormField } from '~/types/CarrierFormField';

import { ActionKeys } from './constants';

export interface FetchCarrierFormFieldsSuccessPayload {
  carrierFormFieldValidations: { [key: string]: ((data: string) => void)[] }; // Object contains keys to Array<func>
  carrierFormFields: CarrierFormField[];
}

export interface FetchCarrierFormFieldsPayload {
  carrier: Carrier;
  formType: CarrierFormType;
}

interface FetchCarrierFormFieldsErrorPayload {
  error: string;
}

// Clear State
export const carrierFormFieldsClearState = () =>
  <const>{
    type: ActionKeys.CARRIER_FORM_FIELDS_CLEAR_STATE,
  };

// Fetch Form Fields
export const fetchCarrierFormFields = (payload: FetchCarrierFormFieldsPayload) =>
  <const>{
    payload,
    type: ActionKeys.FETCH_CARRIER_FORM_FIELDS,
  };

export const fetchCarrierFormFieldsSuccess = (payload: FetchCarrierFormFieldsSuccessPayload) =>
  <const>{
    payload,
    type: ActionKeys.FETCH_CARRIER_FORM_FIELDS_SUCCESS,
  };

export const fetchCarrierFormFieldsError = (payload: FetchCarrierFormFieldsErrorPayload) =>
  <const>{
    payload,
    type: ActionKeys.FETCH_CARRIER_FORM_FIELDS_ERROR,
  };

export type CarrierFormFieldsActions =
  | ReturnType<typeof carrierFormFieldsClearState>
  | ReturnType<typeof fetchCarrierFormFields>
  | ReturnType<typeof fetchCarrierFormFieldsError>
  | ReturnType<typeof fetchCarrierFormFieldsSuccess>;
